import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { endOfWeek, startOfWeek } from 'date-fns';
import { bookingsActions } from '../store/bookings';
import { BookingsScope } from '../store/bookings/bookings.state';
import { selectBookingsCalendarDate, selectFocusedBooking } from '../store/reducers';

@Injectable({ providedIn: 'root' })
export class BookingCalendarNavigationService {
  private store = inject(Store);
  private calendarDate = this.store.selectSignal(selectBookingsCalendarDate(BookingsScope.All));

  handlePrivateBookingSaved(bookingStartDate: Date): void {
    const savedBooking = this.store.selectSignal(selectFocusedBooking)();
    if (savedBooking.recurrence && this.isDateInCurrentCalendarView(bookingStartDate)) {
      this.store.dispatch(bookingsActions.findAll({ scope: BookingsScope.All }));
    } else {
      this.store.dispatch(
        bookingsActions.setCalendarDate({ date: bookingStartDate, scope: BookingsScope.All }),
      );
    }
  }

  private isDateInCurrentCalendarView(date: Date): boolean {
    const weekStart = startOfWeek(this.calendarDate(), { weekStartsOn: 1 });
    const weekEnd = endOfWeek(this.calendarDate(), { weekStartsOn: 1 });
    return date >= weekStart && date <= weekEnd;
  }
}
